import React, { useState, useEffect, useMemo } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';

import api from 'services/api';

import Products from './Products';
import useStyles from './styles';
import { Button } from '@material-ui/core';
import { useWaiterTable } from '../../useWaiterTable';

export default function AddProductsModal({
  isVisible,
  children,
  restaurantId,
  onDismiss,
}) {
  const classes = useStyles();
  const [productList, setProductList] = useState([]);
  const [search, setSearch] = useState('');
  const { reset } = useWaiterTable();

  useEffect(() => {
    if (!isVisible) return;
    if (productList.length) return;

    (async () => {
      const params = {
        restaurant_id: restaurantId,
      };
      const { data } = await api.get('/products', { params });

      setProductList(
        data.object.flatMap((productCategory) => productCategory.products),
      );
    })();
  }, [isVisible, productList, restaurantId]);

  const filteredProducts = useMemo(() => {
    if (search) {
      return productList.filter((product) => {
        // todo: filtrar por código
        return product.name.toLowerCase().includes(search.toLowerCase());
      });
    }

    return productList;
  }, [search, productList]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleDismiss = () => {
    onDismiss();
    reset();
  };

  return (
    <Dialog open={isVisible} onClose={() => true} maxWidth="md">
      <div style={{ position: 'relative' }}>
        <>
          <Box className={classes.container}>
            <Box className={classes.list}>
              <Input
                id="search-products"
                className={classes.searchInput}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                placeholder="Buscar por nome"
                value={search}
                onChange={handleSearch}
              />

              <Products
                products={filteredProducts}
                restaurantId={restaurantId}
              />
            </Box>

            <Box className={classes.list}>{children}</Box>
          </Box>
        </>

        <Box className={classes.buttons}>
          <Button
            type="button"
            variant="outlined"
            fullWidth
            onClick={handleDismiss}
          >
            Cancelar
          </Button>
        </Box>
      </div>
    </Dialog>
  );
}
